export enum DurationState {
    Once = "once",
    Multi = "multi",
    Subscription = "subscription",
}
